let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("8IzJ3")).then(() => parcelRequire('5b9Z9'));